import type { MatterVehicle } from "@/lib/types/Matter";
import { formatVehicleTitle } from "@/lib/utils/format";
import type { TemplateDictionaryOptionsMap } from "./templateDictionaryOptions";

const toStringValue = (value: unknown): string => {
  if (value === undefined || value === null) return "";
  if (typeof value === "number" || typeof value === "bigint") {
    return `${value}`;
  }
  if (typeof value === "string") return value;
  return "";
};

const getVehicleFieldValue = (
  vehicle: MatterVehicle,
  suffix: string,
): string => {
  if (!suffix) {
    return formatVehicleTitle(vehicle);
  }

  switch (suffix) {
    case "Year":
      return vehicle.year ? String(vehicle.year) : "";
    case "Make":
      return vehicle.make;
    case "Model":
      return vehicle.model ?? "";
    default: {
      const propertyKey =
        `${suffix.charAt(0).toLowerCase()}${suffix.slice(1)}` as keyof MatterVehicle;
      if (!(propertyKey in vehicle)) {
        return "";
      }
      return toStringValue(vehicle[propertyKey]);
    }
  }
};

/** Match the vehicle section's existing Apply Vehicle behavior. */
export const getVehicleTemplateFieldValue = (
  vehicle: MatterVehicle,
  baseVariable: string,
  prefix: "clientVehicle" | "defendantVehicle",
  options: TemplateDictionaryOptionsMap,
) => {
  const suffix = baseVariable.slice(prefix.length);
  return suffix.startsWith("Owner")
    ? (options[baseVariable]?.find((option) => option.vehicleId === vehicle.id)
        ?.value ?? "")
    : getVehicleFieldValue(vehicle, suffix);
};
